import * as React from 'react';

import { CircularProgress } from '@emburse/ui-core';

import type { IDropzoneProps } from './Dropzone';

import * as style from './LazyDropzone.styl';

const Dropzone = React.lazy(() => import('./Dropzone').then((module) => ({ default: module.Dropzone })));

interface ILazyDropzoneProps extends IDropzoneProps {
  fallback?: React.ReactNode;
}

export const LazyDropzone: React.FC<ILazyDropzoneProps> = ({ fallback, ...props }) => {
  return (
    <React.Suspense
      fallback={
        fallback || (
          <div className={style.global}>
            <CircularProgress />
          </div>
        )
      }
    >
      <Dropzone {...props} />
    </React.Suspense>
  );
};
